import type {
  ProfileTemplate,
  ProfileTemplatePublishStatus,
} from '@up2stay/up2promo-api-client';

import {
  TemplateRevisionHistory,
  type TemplateRevisionHistoryDict,
} from '@/core/components/profile-templates/template-revision-history';
import { resolveAppAssetFileUrl } from '@/core/lib/file-url';

type TemplateDetailHistoryTabProps = {
  workspaceId: string;
  templateId: string;
  workspaceUsername: string | null;
  previewSampleName: string;
  previewSampleUsername: string;
  canManage: boolean;
  publishStatus: ProfileTemplatePublishStatus;
  liveRevision: number | null;
  revisionHistoryKey: number;
  onRestored: (template: ProfileTemplate) => void;
  dict: TemplateRevisionHistoryDict;
};

export function TemplateDetailHistoryTab({
  workspaceId,
  templateId,
  workspaceUsername,
  previewSampleName,
  previewSampleUsername,
  canManage,
  publishStatus,
  liveRevision,
  revisionHistoryKey,
  onRestored,
  dict,
}: TemplateDetailHistoryTabProps) {
  return (
    <div className="flex min-w-0 flex-col gap-3 w-full">
      <TemplateRevisionHistory
        key={revisionHistoryKey}
        workspaceId={workspaceId}
        templateId={templateId}
        workspaceUsername={workspaceUsername}
        previewSampleName={previewSampleName}
        previewSampleUsername={previewSampleUsername}
        getFileUrl={resolveAppAssetFileUrl}
        canManage={canManage}
        publishStatus={publishStatus}
        liveRevision={liveRevision}
        onRestored={onRestored}
        dict={dict}
      />
    </div>
  );
}
